// The Translator — the order of language switches, pure (tested under node with slow, made-up loads).
//
// The LAST pick wins, whatever arrives first: every pick cancels whatever is still loading, so
// "Deutsch → (before German has loaded) English" ends in English, and "Afrikaans → Deutsch →
// Afrikaans" ends in Afrikaans — never in the language that was abandoned.
//
//   const sw = createSwitch({ load(lang) → Promise<compiled>, show(lang, compiled), english(), onChange() })
//   sw.set(lang, sig)       sig = what the words are (a changed site glossary loads again)
//   sw.state                { shown, loading }
export function createSwitch({ load, show, english, onChange = () => {} }) {
  let seq = 0;
  let shown = 'en';
  let shownSig = 'en';
  let loading = false;
  const done = (my) => { if (my === seq && loading) { loading = false; onChange(); } };
  return {
    async set(want, sig = want) {
      const my = ++seq; // this pick cancels any load still on its way
      if (want === 'en') {
        if (shown !== 'en') english();
        const changed = shown !== 'en' || loading;
        shown = 'en'; shownSig = 'en'; loading = false;
        if (changed) onChange();
        return;
      }
      if (shown === want && shownSig === sig) { done(my); return; } // already on screen
      loading = true; onChange();
      try {
        const compiled = await load(want);
        if (my !== seq) return; // a newer pick won
        show(want, compiled);
        shown = want; shownSig = sig;
      } finally {
        if (my === seq) { loading = false; onChange(); }
      }
    },
    get state() { return { shown, loading }; },
  };
}
